import React from 'react';
import Layout from '../components/layout';

const IndexPage = props => (
  <Layout location={props.location}>{props.children}</Layout>
);

export default IndexPage;
